import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Pulse } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useOrg } from "@/context/OrgContext";
import PageHeader from "@/components/PageHeader";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Events() {
  const { t } = useTranslation();
  const { currentOrg } = useOrg();
  const [events, setEvents] = useState([]);
  const [types, setTypes] = useState([]);
  const [filter, setFilter] = useState(null);

  const load = () => {
    const q = filter ? `?type=${encodeURIComponent(filter)}` : "";
    api.get(`/events${q}`).then((r) => setEvents(r.data)).catch(() => {});
    api.get("/events/types").then((r) => setTypes(r.data)).catch(() => {});
  };
  useEffect(() => { if (currentOrg) load(); }, [currentOrg, filter]);

  return (
    <div>
      <PageHeader title={t("m2.eventsTitle")} subtitle={t("m2.eventsSub")} />

      <div className="flex flex-wrap gap-2 mb-6" data-testid="event-type-filters">
        <button onClick={() => setFilter(null)} className={`text-xs font-mono px-2 py-1 rounded-sm border ${!filter ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-secondary"}`} data-testid="filter-all">all</button>
        {types.map((tp) => (
          <button key={tp.type} onClick={() => setFilter(tp.type)} className={`text-xs font-mono px-2 py-1 rounded-sm border ${filter === tp.type ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-secondary"}`} data-testid={`filter-${tp.type}`}>
            {tp.type} <span className="opacity-60">({tp.count})</span>
          </button>
        ))}
      </div>

      <div className="bg-card border border-border rounded-sm overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-16">{t("m2.sequence")}</TableHead>
              <TableHead>{t("m2.type")}</TableHead>
              <TableHead>{t("m2.actor")}</TableHead>
              <TableHead>{t("m2.business")}</TableHead>
              <TableHead>{t("m2.time")}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {events.map((e) => (
              <TableRow key={e.id} data-testid={`event-row-${e.sequence}`}>
                <TableCell className="font-mono text-xs">#{e.sequence}</TableCell>
                <TableCell><Badge variant="outline" className="rounded-sm font-mono text-[10px]">{e.type}</Badge></TableCell>
                <TableCell className="font-mono text-xs">{e.actor_email || "system"}</TableCell>
                <TableCell>{e.is_business_event && <Badge className="rounded-sm text-[10px] uppercase"><Pulse size={10} className="mr-1" />biz</Badge>}</TableCell>
                <TableCell className="font-mono text-xs text-muted-foreground">{(e.created_at || "").slice(0, 19).replace("T", " ")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
